<template>
  <gg-card>
    <gg-card-header class="gg-card-header">
      <h3 class="mb-0">Domain Change</h3>
      <span class="text--secondary text-sm">Change the primary domain of your hosting account.</span>
    </gg-card-header>

    <gg-card-text>
      <v-row dense>
        <v-col v-if="!hasActiveRequest" cols="12" md="6">
          <p>
            Enter the domain you want to switch to.
          </p>
          <v-form @submit.prevent="submitForm">
            <gg-text-field
              v-model="newDomain"
              label="Domain Name"
              name="domain-name"
              aria-label="Domain Name"
              v-validate="{ url: true, required: true }"
              data-vv-as="Domain Name"
              :error-messages="errors.collect('domain-name')"
            />
            <gg-btn :loading="loading" @click="submitForm">Submit</gg-btn>
          </v-form>
        </v-col>

        <v-col v-else cols="12" md="6">
          <v-alert type="warning" dense style="color:black;">
            Your domain change request is pending and will be processed within a few minutes.
          </v-alert>

          <p v-if="requestData">
            <b>Original domain:</b> {{ requestData.domain_original }} <br/>
            <b>New domain:</b> {{ requestData.domain_new }}
          </p>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ChangePrimaryDomainForm',
  data () {
    return {
      newDomain: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['hosting', 'services', 'domainChangeRequests']),
    requestData () {
      if (this.hosting.domainchange_request === 0 || !this.domainChangeRequests.size) return null

      const request = this.domainChangeRequests.get(Number(this.hosting.domainchange_request))
      if (request?.domain_original) {
        return {
          domain_original: request?.domain_original,
          domain_new: request?.domain_new,
        }
      }
      return null
    },
    hasActiveRequest () {
      if (this.hosting.domainchange_request > 0 && this.domainChangeRequests.get(this.hosting.domainchange_request) !== null) {
        return true
      }

      return this.domainChangeRequests.has(this.hosting.domainchange_request)
    }
  },
  methods: {
    ...mapActions(['makecall', 'getServices', 'reportError', 'reportSuccess']),
    ...mapMutations(['SET_DOMAIN_CHANGE_REQUESTS', 'POPULATE_HOSTING']),
    async submitForm () {
      const valid = await this.$validator.validateAll()
      if (!valid) return null

      this.loading = true
      try {
        const response = await this.makecall({
          method: 'domainchange_request',
          data: {
            service_id: this.hosting.id,
            domain: this.newDomain,
          }
        })
        if (response.result == 'success') {
          this.newDomain = ''
          this.reportSuccess(response.resultmsg || 'Domain change request submitted successfully.')

          this.SET_DOMAIN_CHANGE_REQUESTS([
            ...this.domainChangeRequests.entries(),
            [Number(response.request.id), response.request || null],
          ])

          this.POPULATE_HOSTING({
            ...this.hosting,
            domainchange_request: Number(response.request.id),
          })
          this.getServices({ withDomains: false })
        }
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.gg-card-header span {
  line-height: 1rem;
}
</style>
